import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import PageHeading from "../components/__simple/_pageheading";
import VehicleDetails from "./components/vehicleDetails";
import axios from "axios";
import { toast } from "react-toastify";
import { useLocation, useParams } from "react-router-dom";
import config from "../configuration/config";
import { useHistory } from "react-router";
import { groupBy, mapValues, omit } from "lodash";

import { getData, User_Data_Key } from "../utils/localStorageManager";
import dropDownResetter from "../utils/resetDropDown";
import "./MaintenanceTwo.scss";
import { Price } from "../components/__simple/_price";
import SectionHeading from "../components/sectionHeading";
import CarUser from "./components/CarUser";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);
export default function MyBookings() {
  const { t: trans, i18n } = useTranslation(["eparts", "new", "form", "vehicales", "model", "info", "inputs", "global"]);
  const lang = i18n.language || "ar";
  const { car, fetchType } = useParams();
  const history = useHistory();
  const languageDir = "language-" + lang;
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const [sectionTab, setSectionTab] = useState(query.get("section")?.trim() ?? 0);
  //--------------------------------------------------
  const [vehiclesReservation, setVehiclesReservation] = useState([]);
  const [vehicleDetails, setVehicleDetails] = useState(null);
  const [primaryCategory, setPrimaryCategory] = useState([]);
  const [subPrimaryCategory, setSubPrimaryCategory] = useState([]);
  const [lastSubPrimaryCategory, setLastSubPrimaryCategory] = useState([]);
  const [fSubPrimaryCategory, setFSubPrimaryCategory] = useState([]);
  const [flastSubPrimaryCategory, setFLastSubPrimaryCategory] = useState([]);
  const [allParts, setAllParts] = useState([]);
  const [fAllParts, setFAllParts] = useState([]);
  const [selectedPrimaryCategory, setSelectedPrimaryCategory] = useState("");
  const [selectedSubPrimaryCategory, setSubSelectedPrimaryCategory] = useState("");
  const [selectedSubLastPrimaryCategory, setSubLastSelectedPrimaryCategory] = useState("");
  const [offers, setOffers] = useState([]);
  const [isLoadingUserCars, setLoadingUserCars] = useState(true);
  const [myCars, setMyCars] = useState([]);
  const [activeId, setActiveId] = useState(null);
  const [curentCarId, setCurentCarId] = useState(null);
  useEffect(() => {
    getUserCars();
    featchCarsReservation();
  }, []);

  const featchCarsReservation = async () => {
    var _userData = JSON.parse(getData(User_Data_Key, true));
    var _userID = _userData?.id?.toString() ?? 0;
    var _custID = _userData?.custID?.toString() ?? 0;
    _userID = Number(_userID.toString().split("_")[1]);
    console.log("_userID:>>>>>>>>>>>>>>>>>>>>>>>>>:", JSON.parse(getData(User_Data_Key, true)));
    try {
      setLoadingUserCars(true);

      await axios
        .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/site_featchCarsReservation`, {
          CustID: _custID,
        })
        .then(function (response) {
          var currentCars = response?.data;

          if (currentCars) setVehiclesReservation(currentCars);

          console.log("currentCar:>>>>>>>>>>>>>>>>>>>>>>>>>:", currentCars);

          setLoadingUserCars(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoadingUserCars(false);
        });
    } catch (error) {
      console.log(error);
      setLoadingUserCars(false);
    }
  };
  const getUserCars = async () => {
    var _userID = JSON.parse(getData(User_Data_Key, true))?.id?.toString() ?? 0;
    _userID = Number(_userID.toString().split("_")[1]);

    try {
      setLoadingUserCars(true);

      await axios
        .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteGetUserCars`, {
          userID: Number(_userID),
        })
        .then(function (response) {
          setMyCars(response.data);

          var index = 0;

          index = response?.data?.findIndex(0);
          var currentCar = response?.data[0];

          if (currentCar) setVehicleDetails(currentCar);

          console.log("currentCar:>>>>>>>>>>>>>>>>>>>>>>>>>:", currentCar);
          setActiveId(index);

          setLoadingUserCars(false);
        })
        .catch(function (error) {
          console.log(error);
          setLoadingUserCars(false);
        });
    } catch (error) {
      console.log(error);
      setLoadingUserCars(false);
    }
  };
const getIsExpireDate = (date) => {
  try {
    const targetDate = new Date(date); // تاريخ الحجز (مع الوقت)
    const now = new Date();            // الوقت الحالي

    return targetDate.getTime() <= now.getTime(); 
    // true  => منتهي (التاريخ/الوقت أقل أو يساوي الآن)
    // false => غير منتهي
  } catch (error) {
    console.log("error:", error);
    return true; // في حال الخطأ اعتبره منتهي
  }
};


  const onSliderHomePageChange = (activeIndex) => {
    try {
      setActiveId(activeIndex);
      var currentCar = myCars[activeIndex];

      if (currentCar) setVehicleDetails(currentCar);
      if (currentCar?.CarID) setCurentCarId(currentCar?.CarID);
    } catch (error) {
      console.log("onSliderHomePageChange error ", error);
    }
  };

  // useEffect(async () => {
  //     getVehicleDetails();
  //     await initalCategories();
  // }, []);

  useEffect(async () => {
    console.log("useEffect ReservationFetch>>>>>>>>>>:", vehicleDetails);
    if (vehicleDetails && vehicleDetails?.CarID) {
      ReservationFetch();
      PreviousMaintenance();
    }
  }, [vehicleDetails]);

  const [Reservation, setReservation] = useState(null);
  const [isLoadingReservation, setLoadingReservation] = useState(false);
  const [isFetchedReservation, setFetchedReservation] = useState(false);
  const [cachReservation, setCachReservation] = useState({});
  const ReservationFetch = async () => {
    let data = {};

    try {
      data = JSON.parse(getData(User_Data_Key, true));
    } catch (error) {}

    var userId = data?.custID ? data?.custID : 0;

    setLoadingReservation(true);

    if (cachReservation[vehicleDetails?.CarID]) {
      var cr = cachReservation[vehicleDetails?.CarID];
      setReservation(cr);
      setFetchedReservation(true);
      setLoadingReservation(false);
    } else {
      const Body3 = {
        UserID: userId.toString(),
        VIN: vehicleDetails?.CarID,
      };

      await axios
        .request({
          url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/App_ReservationFetchWithVIN`,
          data: Body3,
          method: "POST",
          responseType: "json",
        })
        .then(function (response) {
          console.log("FetchTypeCart:", response.data);
          setReservation(response.data);
          setFetchedReservation(true);
          setLoadingReservation(false);

          var cr = { ...cachReservation };
          cr[curentCarId] = response.data;
          setCachReservation(cr);
        })
        .catch(function (error) {
          setLoadingReservation(false);
          console.log(error);
          var cr = { ...cachReservation };
          cr[curentCarId] = [];
          setCachReservation(cr);
        });
    }
  };
  const [isLoadingContent, setLoadingContent] = useState(false);
  const [ReservationFilterData, setReservationFilterData] = useState([]);
  const [isActive, setIsActive] = useState(1);

  const [editingBookingGuid, setEditingBookingGuid] = useState(null);
  const [editDate, setEditDate] = useState("");
  const [editTime, setEditTime] = useState("");
  const [actionBusy, setActionBusy] = useState(false);

  const getCustID = () => {
    try {
      return JSON.parse(getData(User_Data_Key, true))?.custID?.toString() ?? "";
    } catch (e) {
      return "";
    }
  };

  const openEditBooking = (res) => {
    const dateStr = res?.Orderdate ? new Date(res.Orderdate).toISOString().slice(0, 10) : "";
    const timeStr = (res?.Ordertime ?? "").toString().slice(0, 5);
    setEditingBookingGuid(res?.GUID ?? null);
    setEditDate(dateStr);
    setEditTime(timeStr || "09:00");
  };

  const closeEditBooking = () => {
    setEditingBookingGuid(null);
    setEditDate("");
    setEditTime("");
  };

  const submitEditBooking = async () => {
    if (!editingBookingGuid || !editDate || !editTime) return;
    const userId = getCustID();
    if (!userId) {
      toast.error(lang === "ar" ? "تعذّر التعرّف على المستخدم" : "Unable to identify user");
      return;
    }
    setActionBusy(true);
    try {
      await axios.post(`${config.controllURL}api/Service/ServiceRequestUpdate`, {
        GUID: editingBookingGuid,
        UserID: userId,
        Orderdate: editDate,
        OrderTime: editTime.length === 5 ? `${editTime}:00` : editTime,
      });
      toast.success(lang === "ar" ? "تم تعديل الحجز بنجاح" : "Booking updated");
      closeEditBooking();
      setCachReservation((prev) => {
        const next = { ...prev };
        delete next[vehicleDetails?.CarID];
        return next;
      });
      await ReservationFetch();
    } catch (err) {
      console.log("update booking failed", err);
      toast.error(lang === "ar" ? "تعذّر تعديل الحجز" : "Could not update booking");
    } finally {
      setActionBusy(false);
    }
  };

  const cancelBooking = async (res) => {
    if (!res?.GUID) return;
    const confirmMsg = lang === "ar" ? "هل أنت متأكد من إلغاء الحجز؟" : "Are you sure you want to cancel this booking?";
    if (!window.confirm(confirmMsg)) return;
    const userId = getCustID();
    if (!userId) {
      toast.error(lang === "ar" ? "تعذّر التعرّف على المستخدم" : "Unable to identify user");
      return;
    }
    setActionBusy(true);
    try {
      await axios.post(`${config.controllURL}api/Service/ServiceRequestDelete`, {
        GUID: res.GUID,
        UserID: userId,
        Reason: lang === "ar" ? "تم الإلغاء من قِبل العميل عبر الموقع" : "Cancelled by customer via website",
      });
      toast.success(lang === "ar" ? "تم إلغاء الحجز" : "Booking cancelled");
      setCachReservation((prev) => {
        const next = { ...prev };
        delete next[vehicleDetails?.CarID];
        return next;
      });
      await ReservationFetch();
    } catch (err) {
      console.log("cancel booking failed", err);
      toast.error(lang === "ar" ? "تعذّر إلغاء الحجز" : "Could not cancel booking");
    } finally {
      setActionBusy(false);
    }
  };

const filterReservation = (type) => {
  if (!isLoadingContent) {
    setLoadingContent(true);
    setIsActive(type);

    const newData =
      type == 1
        ? Reservation?.filter(a => !getIsExpireDate(a.Orderdate)) // غير منتهية
        : Reservation?.filter(a =>  getIsExpireDate(a.Orderdate)); // منتهية

    setReservationFilterData(newData || []);
    setLoadingContent(false);
  }
};

  const [Maintenance, setMaintenance] = useState([]);
  const [MaintenanceDetails, setMaintenanceDetails] = useState({});
  const [isFetchedMaintenance, setFetchedMaintenance] = useState(false);
  const [isLoadingMaintenance, setLoadingMaintenance] = useState(false);
  const PreviousMaintenance = async () => {
    setLoadingMaintenance(true);

    const userId = JSON.parse(getData(User_Data_Key, true))?.custID?.toString() ?? 0;

    const Body3 = {
      UserID: userId.toString(),
      VIN: vehicleDetails?.CarID,
    };

    await axios
      .request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/App_PreviousMaintenanceWithVIN`,
        data: Body3,
        method: "POST",
        responseType: "json",
      })
      .then(function (response) {
        console.log("App_PreviousMaintenance :", response.data);
        setMaintenance(response.data);
        setFetchedMaintenance(true);
        setLoadingMaintenance(false);
      })
      .catch(function (error) {
        setLoadingMaintenance(false);
        console.log(error);
      });
  };

  useEffect(() => {
    console.log("useEffect filterReservation:", isActive);

    filterReservation(isActive);
  }, [isActive, Reservation]);
  //---------------------------------------------------
  // to fetch the vehicle details by passing the vehicleID
  const getVehicleDetails = () => {
    const funSiteGetVehicleDetails = fetchType === "user" ? "SiteGetVehicleDetails" : "SiteGetVehiclePurchase";
    if (car) {
      axios
        .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/${funSiteGetVehicleDetails}`, {
          vehicleID: car,
        })
        .then((response) => {
          const responseData = response.data[0];
          const modelTrans = lang == "ar" ? "Ar" : "En";
          const _vehicle = { ...vehicleDetails };
          _vehicle.groupName = responseData[`Group${modelTrans}`];
          _vehicle.modelName = responseData[`Model${modelTrans}`];
          _vehicle.colorImage = responseData.ColorImage;
          _vehicle.plateNo = responseData[`Board${modelTrans}`];
          _vehicle.vinNo = responseData.VIN;
          _vehicle.carImage = responseData.Image;
          _vehicle.industryYear = responseData.Model ?? "";
          _vehicle.inputDate = responseData.InputDate;
          _vehicle.brand = responseData[`BrandDescription${modelTrans}`];
          _vehicle.userCarName = responseData.UserCarName ?? "";
          intialAllPartsByGroup(responseData.BrandID, responseData.ProductGroupID, responseData.Model);
          console.log("_vehicle >>>>>>>>>>>>>>>>>>>>> :", _vehicle);
          setVehicleDetails(_vehicle);
          initialOffers(responseData.ProductGroupID);
        })
        .catch((error) => {
          console.log("error in fetching the vehicle details,", error);
        });
    }
  };
  //----------------------------------------------------
  //to fetch all the categories
  const initalCategories = async () => {
    const primaryCategoriesBody = {
      objectSettings: {
        metaData: false,
      },
      option: "column",
      fields: "GroupIDMain,DescriptionAr,DescriptionEn",
    };
    const subPrimaryCategoriesBody = {
      objectSettings: {
        metaData: false,
      },
      option: "column",
      fields: "GroupIDMainSup1,DescriptionAr,DescriptionEn,GroupIDMain",
    };
    const lastSubPrimaryCategoriesBody = {
      objectSettings: {
        metaData: false,
      },
      option: "column",
      fields: "GroupIDMainSup2,DescriptionAr,DescriptionEn,GroupIDMainSup1",
    };

    try {
      const primaryCategoriesRequest = axios.request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsSite_categorySP`,
        data: primaryCategoriesBody,
        method: "POST",
        responseType: "json",
      });

      const subPrimaryCategoriesRequest = axios.request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsSite_SupCategory`,
        data: subPrimaryCategoriesBody,
        method: "POST",
        responseType: "json",
      });

      const lastSubPrimaryCategoriesRequest = axios.request({
        url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsSite_ItemsSupCategory`,
        data: lastSubPrimaryCategoriesBody,
        method: "POST",
        responseType: "json",
      });

      await axios
        .all([primaryCategoriesRequest, subPrimaryCategoriesRequest, lastSubPrimaryCategoriesRequest])
        .then(
          axios.spread((category1, category2, category3) => {
            setPrimaryCategory(category1.data.ApiObjectData);
            setSubPrimaryCategory(category2.data.ApiObjectData);
            setLastSubPrimaryCategory(category3.data.ApiObjectData);
          }),
        )
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };
  // filter the sub categories
  const handlFilterSubCategories = (option) => {
    try {
      if (option?.value == "" || option?.value == "0" || option?.value == null) {
        dropDownResetter(() => {
          setFSubPrimaryCategory([]);
          setFLastSubPrimaryCategory([]);
          setSelectedPrimaryCategory("");
        });
        return;
      }
      setSelectedPrimaryCategory(option.value);
      setFSubPrimaryCategory(
        subPrimaryCategory.filter((item) => {
          return item.GroupIDMain == option.value;
        }),
      );
    } catch (err) {
      console.log(err);
    }
  };
  // filter the last sub categories
  const handlFilterLastSubCategories = (option) => {
    try {
      if (option?.value == "" || option?.value == "0" || option?.value == null) {
        dropDownResetter(() => {
          setFLastSubPrimaryCategory([]);
          setSubSelectedPrimaryCategory("");
        });
        return;
      }
      setSubSelectedPrimaryCategory(option.value);
      setFLastSubPrimaryCategory(
        lastSubPrimaryCategory.filter((item) => {
          return item.GroupIDMainSup1 == option.value;
        }),
      );
    } catch (err) {
      console.log(err);
    }
  };
  // to intialize the parts that are base on the group and brand
  const intialAllPartsByGroup = (brandID, groupID, model) => {
    axios
      .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/Site_FeatchPartByVehicle`, {
        brand: Number(brandID),
        group: groupID,
        type: null,
        year: String(model),
      })
      .then((response) => {
        setAllParts(response.data);
        setFAllParts(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // to search by the dropdowns
  const handleOnSearch = () => {
    try {
      let filterResults = [];
      if (selectedPrimaryCategory != "" && selectedPrimaryCategory != 0 && (selectedSubLastPrimaryCategory == "" || selectedSubLastPrimaryCategory == 0) && selectedSubLastPrimaryCategory == "") {
        filterResults = allParts.filter((item) => {
          return item.CategorySPID == selectedPrimaryCategory;
        });
      } else if (selectedPrimaryCategory != "" && selectedPrimaryCategory != 0 && selectedSubLastPrimaryCategory != "" && selectedSubLastPrimaryCategory != 0 && selectedSubLastPrimaryCategory == "") {
        filterResults = allParts.filter((item) => {
          return item.CategorySPID == selectedPrimaryCategory && item.SupCategorySPID == selectedSubPrimaryCategory;
        });
      } else if (selectedPrimaryCategory != "" && selectedPrimaryCategory != 0 && selectedSubLastPrimaryCategory != "" && selectedSubLastPrimaryCategory != 0 && selectedSubLastPrimaryCategory != "") {
        filterResults = allParts.filter((item) => {
          return item.CategorySPID == selectedPrimaryCategory && item.SupCategorySPID == selectedSubPrimaryCategory && item.ItemsSupCategorySPID == selectedSubLastPrimaryCategory;
        });
      } else {
        filterResults = allParts;
      }
      setFAllParts(filterResults);
    } catch (err) {
      console.log(err);
    }
  };
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  useEffect(async () => {
    const results = await fetchUserFavorites();
    setFavoriteProducts(results);
  }, []);
  // to fetch the user favorites
  const fetchUserFavorites = async () => {
    let _favorites = [];
    try {
      const isLogin = getData("isAuthenticated");
      if (isLogin) {
        const { id } = JSON.parse(getData(User_Data_Key, true));
        const userID = Number(id.toString().split("_")[1]);
        const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchUserFavorites`, {
          userID: userID,
        });
        if (response.status == 200) {
          const favorites = response.data;
          _favorites = _favorites.concat(favorites);
        }
      }
    } catch (err) {
      console.log(err);
    }
    return _favorites;
  };
  // to fetch all the user offers
  const initialOffers = (groupID) => {
    try {
      axios
        .post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchOffersByGroup`, {
          GroupID: String(groupID),
        })
        .then((response) => {
          const result = response.data;
          const groupResult = mapValues(groupBy(result, "OfferType"), (fList) => fList.map((items) => omit(items, "OfferType")));
          let groupValues = {};
          Object.assign(groupValues, groupResult);
          let finalResults = [];
          //----------------------------------------------------------------------------
          for (let item in groupValues) {
            const obj = { heading: "", items: [] };
            let title = "";
            const results = groupValues[item].map((item) => item[`Type${trans("model:description")}`]);
            if (results?.length > 0) {
              title = results[0];
            }
            obj.heading = title;
            obj.items = groupValues[item];
            finalResults.push(obj);
          }
          setOffers(finalResults);
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const formatDateTime = (date, time) => {
    try {
      if (date) {
        let dateNow = new Date(date);

        if (time) {
          let timeNow = new Date("2023-02-26T" + time);

          dateNow.setHours(timeNow.getHours(), timeNow.getMinutes(), timeNow.getSeconds());
        }

        var formatDate = { year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", hour12: true, minute: "2-digit" };

        if (lang.language === "en") {
          return dateNow.toLocaleDateString("en-US", formatDate);
        } else {
          return dateNow.toLocaleDateString("en-US", formatDate);
          // return dateNow.toLocaleDateString('ar-US', formatDate);
        }
      } else {
        return date;
      }
    } catch (error) {
      console.log(error);
      return date;
    }
  };

  //------------------------------------------------------------------------------
  useEffect(() => {
    if (myCars?.length == 1) onSliderHomePageChange(0);
  }, [myCars]);

  //------------------------------------------------------------------------------

  const handelOnSlideChange = (swiperCore) => {
    console.log("swiperCore ", swiperCore);
    try {
      let swiperCoreValues = {
        activeIndex: 0,
        snapIndex: 0,
        previousIndex: 0,
        realIndex: 0,
      };
      swiperCoreValues = swiperCore;

      onSliderHomePageChange(swiperCore?.activeIndex);
    } catch (error) {}
  };

  return (
    <div className={languageDir}>
      <PageHeading title={trans("info:my-bookings")} />

      <SectionHeading
        hasRuler={false}
        infoText={trans("user:private_cars_note")}
        // title={trans("user:private_cars")}
      >
        <Swiper
          spaceBetween={0}
          slidesPerView={2}
          breakpoints={{
            576: {
              slidesPerView: 4,
            },
          }}
          resizeObserver={"true"}
          watchSlidesVisibility
          watchSlidesProgress
          autoplay={false}
          loop={false}
          observer={true}>
          {myCars?.map((car, index) => {
            return (
              <SwiperSlide className={"px-3 my-3"} key={index}>
                <CarUser
                  onclick={() => {
                    onSliderHomePageChange(index);
                  }}
                  withMoreLinke={false}
                  key={index + 5000}
                  inputDate={car.InputDate}
                  showDetails={false}
                  active={activeId == index}
                  id={car.CarID}
                  img={car.Image ? car.Image : "/assets/images/parts/default.png"}
                  name={car[`Model${trans("model:description")}`]}
                  brand={car[`Brand${trans("model:description")}`]}
                  brandIcon={car.Icon ? "data:image/png;base64," + car.Icon : null}
                  brandImage={car.IconImage ? "data:image/png;base64," + car.IconImage : null}
                  link={"/user/vehicles/privateVehicles/" + car.CarID + "/" + car.FetchType}
                />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </SectionHeading>
      {/* 
            <VehicleDetails
                // carImage={vehicleDetails?.Image ? vehicleDetails?.Image : '/assets/images/parts/default.png'}
                createdInput={vehicleDetails?.InputDate}
                plateNo={vehicleDetails?.plateNo}
                carModelTitle={vehicleDetails?.modelName}
                // carBrand={vehicleDetails[lang=="ar"?"BrandDescriptionAr":"BrandDescriptionEn"]}
                colorImage={vehicleDetails?.colorImage}
                industryYear={vehicleDetails?.industryYear}
                structureNo={vehicleDetails?.CarID}
                // carNameTitle={vehicleDetails[lang=="ar"?"GroupDescriptionAr":"GroupDescriptionEn"]}
                userCarName={vehicleDetails?.alias} /> */}

      <Tabs selectedTabClassName="tab-active" defaultIndex={sectionTab}>
        <div className="private-vehicle-tab-box my-8 px-20">
          <TabList className="private-vehicle-tabs-container">
            <Tab className="text-size-16r">{trans("info:maintenance-bookings")}</Tab>
            <span className="vertical-separater"></span>
            <Tab className="text-size-16r">{trans("info:previous-maintenance")}</Tab>
            {
              <>
                <span className="vertical-separater"></span>
                <Tab className="text-size-16r">{trans("info:car-bookings")}</Tab>
              </>
            }
          </TabList>
        </div>

        <TabPanel>
          <div>
            {ReservationFilterData?.map((res, index) => {
              const canEdit = res?.OrderStatusID === "Created" && !getIsExpireDate(res?.Orderdate) && !!res?.GUID;
              const isEditingThis = editingBookingGuid && editingBookingGuid === res?.GUID;
              return (
                <div key={index} className={`${isActive ? "z-details-box-m-white" : "z-details-box-m"}  my-10`}>
                  <div className="z-right-side-imageBox">
                    <div className="z-boxImage-s p-5">
                      <img alt="" className="z-right_image_s" src="/assets/images/more-images/Group 23663.png" />
                    </div>
                  </div>

                  <div className="z-middle-lineM"></div>
                  <div className="z-left-side-details-m p-10 flex flex-col nice-gap-2rem">
                    <p className="z-title text-black text-bold text-24 text-line-clamp text-line-clamp-1">{lang == "ar" ? res?.DescriptionAr : res?.DescriptionEn}</p>

                    <p className="z-text text-black text-20">
                      {trans("info:order-number")}: <span className="z-gray-text text-gray  text-20">{res?.ReceptionID}</span>
                    </p>

                    {
                      <p className="z-text text-black  text-20">
                        {trans("info:booking-date")}:{" "}
                        <span dir={"ltr"} className="z-gray-text text-gray  text-20">
                          {formatDateTime(res.Orderdate, res.Ordertime)}
                        </span>
                      </p>
                    }

                    {isEditingThis && (
                      <div className="flex flex-col nice-gap-1rem mt-3 p-3" style={{ border: "1px solid #e0e0e0", borderRadius: "8px" }}>
                        <div className="flex flex-row nice-gap-1rem nice-flex-wrap">
                          <label className="text-16 text-black">
                            {lang === "ar" ? "التاريخ" : "Date"}:
                            <input
                              type="date"
                              value={editDate}
                              onChange={(e) => setEditDate(e.target.value)}
                              className="mx-2 p-1"
                              style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                            />
                          </label>
                          <label className="text-16 text-black">
                            {lang === "ar" ? "الوقت" : "Time"}:
                            <input
                              type="time"
                              value={editTime}
                              onChange={(e) => setEditTime(e.target.value)}
                              className="mx-2 p-1"
                              style={{ border: "1px solid #ccc", borderRadius: "4px" }}
                            />
                          </label>
                        </div>
                        <div className="flex flex-row nice-gap-1rem">
                          <button
                            type="button"
                            disabled={actionBusy}
                            onClick={submitEditBooking}
                            className="btn py-2 px-4 text-white text-14 bg-primary">
                            {lang === "ar" ? "حفظ التعديل" : "Save"}
                          </button>
                          <button
                            type="button"
                            disabled={actionBusy}
                            onClick={closeEditBooking}
                            className="btn py-2 px-4 text-14 bg-gray">
                            {lang === "ar" ? "إلغاء" : "Cancel"}
                          </button>
                        </div>
                      </div>
                    )}

                    {canEdit && !isEditingThis && (
                      <div className="flex flex-row nice-gap-1rem mt-3">
                        <button
                          type="button"
                          disabled={actionBusy}
                          onClick={() => openEditBooking(res)}
                          className="btn py-2 px-4 text-white text-14 bg-primary">
                          {lang === "ar" ? "تعديل الحجز" : "Edit booking"}
                        </button>
                        <button
                          type="button"
                          disabled={actionBusy}
                          onClick={() => cancelBooking(res)}
                          className="btn py-2 px-4 text-white text-14 bg-error">
                          {lang === "ar" ? "إلغاء الحجز" : "Cancel booking"}
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </TabPanel>
        <TabPanel>
          <div>
            {Maintenance?.map((res, index) => {
              return (
                <div key={index} className={`${isActive ? "z-details-box-m-white" : "z-details-box-m"}  my-10`}>
                  <div className="z-right-side-imageBox">
                    <div className="z-boxImage-s p-5">
                      <img alt="" className="z-right_image_s" src="/assets/images/more-images/Group 23663.png" />
                    </div>
                  </div>

                  <div className="z-middle-lineM"></div>
                  <div className="nice-relative z-left-side-details-m p-10 flex flex-col nice-gap-2rem">
                    <p className="z-title text-black text-bold text-24 text-line-clamp text-line-clamp-1">{res?.Description}</p>

                    <p className="z-text text-black">
                      {trans("info:order-number")}: <span className="z-gray-text text-gray">{res?.OrderID}</span>
                    </p>

                    {
                      <p className="z-text text-black">
                        {trans("info:maintenance-date")}:{" "}
                        <span dir={"ltr"} className="z-gray-text text-gray  language-en">
                          {formatDateTime(res?.CompleteDate, null)}
                        </span>
                      </p>
                    }

                    {/* <p className="z-text text-black">
                                                <span className="green text-primary">
                                                    {res?.Price && <Price price={parseFloat(res?.Price.toFixed(2))} />}
                                                </span>
                                            </p> */}

                    {res.SalesInvoiceGUID && res.OrderID && (
                      <div className="flex flex-row text-16 nice-pointer nice-align-item-center nice-absolute  nice-inset-inline-end  nice-inset-block-end">
                        <a
                          target={"_blank"}
                          style={{ minHeight: "" }}
                          href={`https://cloud.hassanjameel.com.sa/tools/webreports?ObjectName=MInvoiceOnline&GUID=${res.SalesInvoiceGUID}&ReportID=154A6627-7E23-4DBA-9B62-6225FA1A2FE3&type=OnlineRegistration`}
                          download={res.OrderID?.replaceAll(" ", "-") + "_user-manual.pdf"}
                          className={"text-primary text-20"}>
                          {/* {trans("new:bill")} */}
                          <i className="icon-documents"></i>
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </TabPanel>
        <TabPanel>
          <div>
            {vehiclesReservation?.map((res, index) => {
              return (
                <div key={index} className={`${isActive ? "z-details-box-m-white" : "z-details-box-m"}  my-10`}>
                  <div className="z-right-side-imageBox">
                    <div className="z-boxImage-s ">
                      <img alt="" className="z-right_image_s" src={res.Partimg ? config.FilePathURL + res.Partimg : ""} />
                    </div>
                  </div>

                  <div className="z-middle-lineM"></div>
                  <div className="nice-relative z-left-side-details-m p-10 flex flex-col nice-gap-2rem">
                    <p className="z-title text-black text-bold text-24 ">{lang == "ar" ? res?.DescriptionAr : res?.DescriptionEn}</p>

                    <p className="z-text text-20 text-black">
                      {trans("new:Reservation_number")}: <span className="z-gray-text text-gray">{res?.OrderID}</span>
                    </p>

                    {
                      <p className="z-text text-20 text-black">
                        {trans("info:booking-date")}:{" "}
                        <span dir={"ltr"} className="z-gray-text text-gray  language-en">
                          {formatDateTime(res?.CreatedAt, null)}
                        </span>
                      </p>
                    }
                    {res.RelatedOrderID && (
                      <p className="z-text text-20 text-black">
                        {trans("info:order-number")}:{" "}
                        <span dir={"ltr"} className="z-gray-text text-gray  language-en">
                          {res.RelatedOrderID}
                        </span>
                      </p>
                    )}

                    <div className="flex flex-row text-16 nice-pointer nice-align-item-center md:absolute nice-inset-inline-end nice-inset-block-end">
                      {/* حالة الطلب ملغى */}
                      {res.SalesOrderStatusID === "Canceled" ? (
                        <div className="text-16 p-2 text-bold own-order-history-item-header-status bg-error box-circle">{lang === "ar" ? res.statusAr : res.statusen}</div>
                      ) : !res.RelatedOrderID || (res.RelatedOrderID && res.RelatedOrderStatusID === "Canceled") ? (
                        /* زر إكمال الطلب */
                        res.buyOnline ? (
                          <div
                            className="btn nice-flex-row py-5 px-5 text-white text-14 bg-primary"
                            onClick={() => {
                              history.push({
                                pathname: `/car/accessories/${res?.SN}/${res?.Slug}`,
                                search: `orderDraftID=${res?.OrderGUID}&isReservation=true`,
                              });
                            }}>
                            {trans("new:goToCompleteOrder")}

                            <div className={"mx-2 " + (lang === "ar" ? "rotate-180" : "")}>
                              <svg xmlns="http://www.w3.org/2000/svg" height="15" width="20" viewBox="0 0 448 512">
                                <path
                                  fill="#ffffff"
                                  strokeWidth="2"
                                  d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"
                                />
                              </svg>
                            </div>
                          </div>
                        ) : null
                        /* حالة الحجز فقط */
                        // <div className="text-16 p-2 text-bold own-order-history-item-header-status bg-gray box-circle">{trans("new:chassisReserved")}</div>
                      ) : res.RelatedOrderID ? (
                        /* حالة الطلب مؤكد */
                        <div className="text-16 p-2 text-bold own-order-history-item-header-status bg-primary box-circle">{lang === "ar" ? "مؤكد" : "Confirmed"}</div>
                      ) : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </TabPanel>
      </Tabs>
    </div>
  );
}
